"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterfaceContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("primeflex/primeflex.css");
require("primeicons/primeicons.css");
require("primereact/resources/primereact.css");
require("primereact/resources/themes/lara-light-blue/theme.css");
require("@/app/shared/css/sumo.css");
require("@/app/shared/css/sumoCustom.css");
require("@/app/shared/css/sumoSpacing.css");
require("@/app/shared/css/sumoUtils.css");
const api_1 = require("primereact/api");
const InterfaceContextProvider = ({ styleContainer, children }) => {
    return (0, jsx_runtime_1.jsx)(api_1.PrimeReactProvider, { value: { styleContainer }, children: children });
};
exports.InterfaceContextProvider = InterfaceContextProvider;
